<template>
  <div class="login">

    <svg-icon
      :icon="logoIcon"
      :height="113"
      :width="231"
      class="login__logo"
    ></svg-icon>

    <div class="login__loader" v-if="loading">
      <loader-dots></loader-dots>
    </div>

    <form class="login__form" @submit.prevent="handleSubmit" v-show="!loading">

      <input class="login__input login__username" placeholder="Warner Media Email Address" v-model="username">

      <input type="password" class="login__input login__password" placeholder="Password" v-model="password">

      <simple-button
        text="Sign In"
        class="login__simple-button"
        :class="buttonClass"
        :disabled="!buttonClickable"
      ></simple-button>

      <error-modal ref="errorModal" :message="errorMessage" @dismiss="clearError"></error-modal>

    </form>
    <v-row class="justify-center mt-12 flex">
      <v-col md="1">
        <v-img
          src="https://login.wbd.com/images/WBDLogo.png"
        >
        </v-img>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SimpleButton from '@/components/common/simpleButton'
import {SET_ERROR} from '@/store/modules/auth/constants'
import { ErrorModal } from '@/components/common/feedbackModal'
import SvgIcon from '@/components/common/svgIcon'
import logoIcon from '@/assets/AM_Logo_Final/White/audience-matters-logo-white.svg'
import LoaderDots from '@/components/common/loaderDots'

export default {
  components: {
    SimpleButton, ErrorModal, SvgIcon, LoaderDots
  },
  props: {
    signInEvent: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      username: '',
      password: '',
      errorMessage: '',
      logoIcon
    }
  },
  computed: {
    authError () {
      return this.$store.state.auth.error
    },
    loading () {
      return this.$store.state.auth.loading
    },
    buttonClass () {
      return this.buttonClickable ? 'login__simple-button--active' : 'login__simple-button--inactive'
    },
    buttonClickable () {
      return this.username.length > 0 && this.password.length > 0 && !this.authError
    }
  },
  methods: {
    handleSubmit () {
      this.$emit('submit', {username: this.username, password: this.password})
    },
    clearError () {
      this.$store.dispatch(SET_ERROR, null)
    }
  },
  watch: {
    authError (message) {
      this.errorMessage = message

      if (message) this.$refs.errorModal.open()
    }
  }
}
</script>

<style lang='scss'>

.login {
  height: 100%;
  width: 100%;
  box-sizing: padding-box;
  background-image: url('https://login.wbd.com/images/BG/background.png');
  background-repeat: repeat;
  overflow-y: auto;

  &__loader {
    display: flex;
    padding-top: 100px;
    justify-content: center;
  }

  &__logo {
    display: block;
    margin: 205px auto 0 auto;
    fill: white;
  }

  &__input {
    display: block;
    width: 270px;
    padding: 9px 15px;
    margin: 74px auto 0 auto;
    border: none;
    font-size: 17px;
    line-height: 20px;
    background-color: #e5eeff;
  }

  &__password {
    margin-top: 18px;
  }

  &__input:focus {
    outline: none;
  }

  &__simple-button {
    margin: 40px auto 0 auto;
    background: black;
  }

  &__simple-button--inactive {
    background: rgb(198, 204, 209);
    cursor: default;
  }

  &__simple-button--inactive:hover {
    color: white;
  }

}

</style>



// WEBPACK FOOTER //
// Login.vue?5f8427fa